import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { Site } from '@debbie/common/dist/index.js';
import helpers from '@debbie/common/dist/economy/helpers/index.js';
import { VoucherTypeIds, VoucherTypeSetting, } from '@debbie/common/dist/economy/vouchers/index.js';
import { Money, Table, Tag } from '../../index.js';
import THEME from '../../../theme.js';
import Billings from '../Billings.js';
import CaseVoucherInfoActions from './CaseVoucherInfoActions.js';
import CaseVoucherInfoMeta from './CaseVoucherInfoMeta.js';
import { CaseVoucherInterestSettings } from '@debbie/common/dist/economy/vouchers/setup.js';
import { h } from '@debbie/cortex/dist/index.js';
import { getExpirationSettings } from '@debbie/common/dist/economy/helpers/interest/index.js';
import { selectTenant } from '@debbie/cortex/dist/tenant/selectors.js';
import { useCaseVouchersByCase } from '@debbie/cortex/dist/case-vouchers/index.js';
import { useDocumentsByReference } from '@debbie/cortex/dist/documents/index.js';
import { useCreditor } from '@debbie/cortex/dist/creditors/index.js';
import { TenantType } from '@debbie/common/dist/tenants/index.js';
const CaseVoucherInfo = (props) => {
    const { caseVoucher, caseVouchers, singleCase } = props;
    const lang = useSelector((s) => s.lang);
    const tenant = useSelector(selectTenant);
    const documentsLoader = useDocumentsByReference(singleCase?.caseId);
    const documents = h.hasData(documentsLoader) ? documentsLoader.data : null;
    const creditorLoadable = useCreditor(singleCase?.creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const site = useSelector((s) => s.site);
    const caseVouchers_ = useCaseVouchersByCase(singleCase?.caseId);
    const _caseVouchers = h.hasData(caseVouchers_) ? caseVouchers_.data : null;
    const until = moment().format();
    const caseVouchersWithHistory = _caseVouchers &&
        tenant &&
        creditor &&
        documents &&
        helpers.interest.calculate(JSON.parse(JSON.stringify(_caseVouchers)), documents, getExpirationSettings(tenant, creditor), until, {
            appendHist: true,
        });
    const voucherWithInterestHistory = caseVouchersWithHistory &&
        caseVouchersWithHistory.find((v) => v.caseVoucherId === caseVoucher.caseVoucherId);
    return (React.createElement(React.Fragment, null,
        React.createElement(CaseVoucherInfoMeta, { caseVoucher: caseVoucher, caseVouchers: caseVouchers, singleCase: singleCase }),
        React.createElement(Tags, null, caseVoucher.tags?.map((tag, key) => {
            return (React.createElement(Tag, { key: key }, lang.caseVoucherTags[tag.tag] || tag.tag));
        })),
        voucherWithInterestHistory &&
            voucherWithInterestHistory.setting &&
            CaseVoucherInterestSettings.includes(voucherWithInterestHistory.setting) &&
            voucherWithInterestHistory.interestHistory && (React.createElement(InterestHistory, null,
            React.createElement("h3", null, lang.economy.voucherInfoInterestHis),
            React.createElement(Table, { zebra: true },
                React.createElement("tr", null,
                    React.createElement("th", { style: { textAlign: 'left' } }, lang.economy.voucherInfoIfrom),
                    React.createElement("th", { style: { textAlign: 'left' } }, lang.economy.voucherInfoITo),
                    React.createElement("th", { style: { textAlign: 'left' } }, lang.economy.voucherInfoIInterval),
                    React.createElement("th", { style: { textAlign: 'right' } }, lang.economy.voucherInfoIRVA),
                    voucherWithInterestHistory.setting ===
                        VoucherTypeSetting.CompoundInterest && (React.createElement("th", { style: { textAlign: 'right' } }, lang.economy.voucherInfoICompoundedAmount)),
                    React.createElement("th", { style: { textAlign: 'right' } }, lang.economy.amount)),
                voucherWithInterestHistory.interestHistory &&
                    voucherWithInterestHistory.interestHistory.map((item, key) => (React.createElement("tr", { key: key },
                        React.createElement("td", null, moment(item.from).format(THEME.DATE_FORMAT_SHORT)),
                        React.createElement("td", null, moment(item.to).format(THEME.DATE_FORMAT_SHORT)),
                        React.createElement("td", null,
                            moment(item.to).diff(moment(item.from), 'days'),
                            ' ',
                            lang.economy.voucherInfoIDays),
                        React.createElement("td", { style: { textAlign: 'right' } },
                            React.createElement("small", null,
                                "(",
                                parseFloat((item.interest * 100).toFixed(3)),
                                " %)"),
                            ' ',
                            React.createElement(Money, { amount: item.referenceVoucherBalance })),
                        voucherWithInterestHistory.setting ===
                            VoucherTypeSetting.CompoundInterest && (React.createElement("td", { style: { textAlign: 'right' } },
                            React.createElement(Money, { amount: item.capitalizedInterestBalance || 0 }))),
                        React.createElement("td", { style: { textAlign: 'right' } },
                            React.createElement(Money, { amount: item.amount })))))))),
        caseVoucher.voucherTypeId === VoucherTypeIds.DEPOSIT &&
            tenant?.type === TenantType.Agency && (React.createElement(Billings, { depositCaseVoucherId: caseVoucher.caseVoucherId })),
        React.createElement("br", null),
        site === Site.Caseworker && React.createElement(CaseVoucherInfoActions, { ...props })));
};
export default CaseVoucherInfo;
const Tags = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: 14px;
  padding: 6px 0;
`;
const InterestHistory = styled.div `
  margin-bottom: 20px;
`;
//# sourceMappingURL=CaseVoucherInfo.js.map